import React from 'react';
import { Fab, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { goToGPTOptions } from '../../../utils/openai';
import { tracking } from '../../../utils/tracking';
import { connect } from 'react-redux';
import { getTeamAiBotLogo } from '../../../utils/teamAiSetting/getTeamAiLogo';
import { withRouter } from 'react-router-dom';

const ImageStyle = {
  width: '100%'
};

const ChatGPTFab = props => {
  const { style } = props;
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const onClick = () => {
    tracking('Click on ChatGPT - Main Page');
    goToGPTOptions(props.viewingClient);
  };

  const aiLogoSRC = getTeamAiBotLogo(props.teamAiSettings);

  return (
    <Fab
      className="fab"
      size="medium"
      variant="circular"
      onClick={onClick}
      style={{
        position: 'fixed',
        zIndex: 10,
        bottom: isXsScreen ? 'calc(124px + var(--bottom-padding))' : 135,
        right: isXsScreen ? 20 : 50,
        width: isXsScreen ? 50 : 60,
        height: isXsScreen ? 50 : 60,
        ...style
      }}
    >
      <img alt="A.I. Pro" src={aiLogoSRC} style={ImageStyle} />
    </Fab>
  );
};

const container = connect(state => ({
  teamAiSettings: state.team.aiSettings,
  viewingClient: state.client.viewingClient
}));

export default withRouter(container(ChatGPTFab));
